/**
 * @module store/actions
 *
 * @version 1.0.0
 * @copyright Kosmos 2018
 */

/**
 * Action: Первичной инициализации приложения
 */
const appInit = async ({ dispatch }) => {
  await dispatch('user/checkIsLoginUser', undefined, { root: true });
  await dispatch('settings/getAppSettings', undefined, { root: true });
};


/**
 * Action: Вторичной инициализации приложения где делаются запросы к API
 *
 * Инициализация разнесена на две стадии для ускорения первичной загрузки приложения.
 */
const secondStageInit = async () => {

};

export default {
  appInit,
  secondStageInit,
};
